import template from './alert.html';
import './alert.global.css';

const ICONS = {
  success: 'check-circle',
  warning: 'exclamation-circle',
  danger: 'times-circle',
};

class AlertController {
  get icon() {
    return ICONS[this.type];
  }
}

export const AlertComponent = {
  controller: AlertController,
  bindings: {
    type: '@',
  },
  transclude: true,
  template,
};
